import styled from 'styled-components';

import {
  flexbox,
  alignItems,
  justifyContent
} from '../../../../../styles/helpers/flexbox';

export const DataRow = styled.div((props) => {
  const { colours } = props.theme;

  return `
    ${justifyContent('flex-start')};
    ${flexbox()};

    border-bottom: 1px solid ${colours.grey[300]};
  `;
});

export const NoDataView = styled.div(() => {
  return `
    ${flexbox()};

    text-align: center;
    padding: 20px 10px;
  `;
});

export const HeaderText = styled.div`
  padding-left: 5px;
`;

export const HeaderContainer = styled.div`
  ${justifyContent('space-between')};
  ${flexbox()};
  ${alignItems('center')};

  width: 95%;
  font-weight: 900;
  text-rendering: geometricPrecision;
  svg {
    width: 12px;
  }
`;

export const DataValue = styled.div`
  ${justifyContent('center')};
  ${flexbox()};
  ${alignItems('center')};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 10px;
  display: block;

  width: 50%;
  padding: 2px 0 2px 5px;
`;

export const HeaderCell = styled.div`
  font-size: 12px;
  font-weight: bold;
  padding: 2px 0;
`;

export const BodyCell = styled.div`
  font-size: 10px;
`;

export const ResultContainer = styled.div`
  max-height: 200px;
  width: 200px;
  font-size: 12px;
`;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/student-result-table/student-result-table.styled.js